"use strict";

(function () {
    var self = Fotobook.containers = {

        /**
         * Разруппировать контейнеры
         * @param id
         */
        ungroup(id){
            Fotobook.ajax.postJSON("/editor/container/un-group", {
                "data" : {
                    "id": id,
                }
            }).then((response) => {
                Fotobook.isModified = true;
                Fotobook.book.updateBookFromResponse(response.data);
            }).catch(() => null);
        },

        /**
         * Сгруппировать контейнеры
         * @param params
         * @returns Promise
         */
        group: function(params){
            let promise = Fotobook.ajax.postJSON("/editor/container/group", {
                "data" : params,
            }).then((response) => {
                Fotobook.isModified = true;
                Fotobook.book.updateBookFromResponse(response.data);
                return response;
            });
            promise.catch(() => null);
            return promise;
        },

        /**
         * Восстановить оригинальное состояние страниц(ы)
         * @param ids
         * @return Promise
         */
        restoreOrigAttrs: function(ids){
            Fotobook.ajax.postJSON("/editor/container/restore-original-attributes", {
                "data" : {
                    "ids" : ids,
                },
            }).then((response) => {
                Fotobook.isModified = true;
                const $book = $(Fotobook.book.book);
                for (var id in response.data.containers){
                    if (response.data.containers.hasOwnProperty(id)) {
                        var cont = response.data.containers[id];

                        if (cont.type === Fotobook.ContainerType.CAPTION) {
                            var selector = Fotobook.book.getContainerSelector(id),
                                $old = $(selector).attr("data-deleted", 1),
                                widget = $(Fotobook.book.book).find(selector).data("fotobook-containerEditor");

                            if (widget) {
                                cont.caption.content = widget._getSaveContent();
                            } else {
                                cont.caption.content = $book.find(selector).find(".text-content").html();
                            }
                            // надо бы переделать, очень криво
                            if (cont.caption.type === Fotobook.CaptionType.PLAIN) {
                                var $content = $($.parseHTML("<div>" + cont.caption.content +"</div>"));
                                $content.html($content.children()[0].innerHTML);
                                Fotobook.textValidator.validate($content, {
                                    "focus" : false,
                                    "family" : cont.caption.font_id,
                                });
                                cont.caption.content = $content.html();
                                $content.remove();
                            }
                            if (cont.page_id) {
                                Fotobook.book.removeContainer($old);
                                Fotobook.book.addContainerToPage(cont);
                            } else if (cont.group_id) {
                                var group = $(Fotobook.book.getContainerSelector(cont.group_id)),
                                    $page = group.closest(".book-page"),
                                    dX = parseFloat($page.attr("data-dx")),
                                    region = $page.attr("data-page_type");
                                $old.replaceWith(Fotobook.book.drawContainer(cont, dX, region));
                            }
                            if (widget) {
                                $(Fotobook.book.book).find(selector).containerEditor();
                            }
                        }
                    }
                }
                Fotobook.book.updateBookFromResponse(response.data);
            });
        },

        /**
         * Применить форматирование текущего календаря для всех календарей
         * @param id
         * @return Promise
         */
        applyCalendarFormatsToAll: function(id) {
            Fotobook.ajax.postJSON("/editor/container/apply-calendar-formats-to-all", {
                "data": {
                    "id": parseInt(id, 10),
                },
            }).then((response) => {
                Fotobook.isModified = true;
                Fotobook.book.updateBookFromResponse(response.data);
            });
        },

        setShapeByPhoto: function(id){
            Fotobook.ajax.postJSON("/editor/container/set-shape-by-photo", {
                "data" : {
                    "id": parseInt(id, 10),
                }
            }).then((response) => {
                Fotobook.isModified = true;
                Fotobook.book.updateBookFromResponse(response.data);
            });
        },

        setContainerOptimalQuality(id){
            Fotobook.ajax.postJSON("/editor/container/set-optimal-quality", {
                "data" : {
                    "id" : parseInt(id, 10),
                }
            }).then((response) => {
                Fotobook.isModified = true;
                Fotobook.book.updateBookFromResponse(response.data);
            });
        },

        /** Запрос на изменение атрибутов контейнера */
        changeContainerAttrs(params) {
            return Fotobook.ajax.postJSON('/editor/container/change-attributes', {
                contentType: 'application/json; charset=utf-8',
                data: {
                    containers: params,
                },
            }).then((response) => {
                Fotobook.isModified = true;
                Fotobook.book.updateBookFromResponse(response.data, params);
                return response;
            }).catch((reason) => {
                for (const idx in params) {
                    if (params.hasOwnProperty(idx)) {
                        const cont = params[idx];
                        const $old = $(Fotobook.book.book).find(Fotobook.book.getContainerSelector(cont.id));
                        const data = $old.data('fotobook-initial');
                        if (data && cont.move_started !== undefined && cont.move_started >= data['time']) {
                            $old.removeData('fotobook-initial');
                            Fotobook.book.restoreInitialCoordinates($old, data);
                        }
                    }
                }
                setTimeout(() => {
                    const widget = Fotobook.book.getSelectionWidget();
                    if (widget) {
                        widget.updateToolbarPosition();
                    }
                }, 0);
                throw reason;
            });
        },

        // del foto from container
        delFoto: function(){
            var $cont = $(this).closest(".foto-container,.bg"),
                params = {};

            //удаление фотонакладки в режиме 5 кликов
            if($cont.hasClass(Fotobook.CONT_SUBTYPE_FOTOWINDOW_CLASS) && $cont.hasClass('empty') && $(':root.edit-mode-instant').length) {
                Fotobook.book.removeContainerConfirmation($cont).then(() => {
                    setTimeout(() => {
                        $cont.hide();
                        Fotobook.book.removeContainersSend($cont);
                    }, 0);
                }).catch(() => {
                    Fotobook.book.restoreInitialCoordinates($cont);
                });
                return;
            }

            if ($cont.hasClass("bg")) {
                var $bg = Fotobook.book.getSingleOrSpreadBg($cont);
                if (!$bg.length) {
                    return;
                }
                if ($bg.length == 1) {
                    var $bg2 = Fotobook.book.getAdjacentBg($bg);
                    if ($bg2.length) {
                        params[$bg2.attr("data-id")] = {
                            "foto_position": Fotobook.FotoPosition.FULL,
                        }
                    }
                }
                $bg.find(".bg-content").each(function(){
                    params[this.getAttribute("data-id")] = {
                        "foto_id": 0,
                        "foto_position": Fotobook.FotoPosition.FULL,
                    };
                });
            } else {
                params[$cont.attr("data-id")] = {
                    "foto_id": 0,
                    "foto_position": Fotobook.FotoPosition.FULL,
                };
            }
            Fotobook.containers.changeContainerAttrs(params);
        },

        /** Get image data. */
        getImageData(container) {
            const image = container.querySelector('.apply-mask .foto-image');

            return {
                angle: Number(image.style.getPropertyValue('--foto-angle')),
                path: image.getAttribute('xlink:href'),
                width: Number(image.getAttribute('data-width')),
                height: Number(image.getAttribute('data-height')),
            };
        },

        /**
         * @return {FramingArea}
         */
        getFramingArea(container) {
            const image = container.querySelector('.foto-image');
            return {
                crop_cx: Number(image?.getAttribute('data-crop_cx')) || 50,
                crop_cy: Number(image?.getAttribute('data-crop_cy')) || 50,
                crop_width: Number(image?.getAttribute('data-crop_width')) || 100,
                crop_height: Number(image?.getAttribute('data-crop_height')) || 100,
            };
        },

        getRealSize(/** HTMLElement */ htmlElement) {
            const size = {
                height: 100,
                width: 100,
            };
            for (
                let currentElement = htmlElement;
                currentElement;
                currentElement = currentElement.parentNode?.closest('.page-container')
            ) {
                size.height = size.height * Number(currentElement.getAttribute('data-height')) / 100;
                size.width = size.width * Number(currentElement.getAttribute('data-width')) / 100;
            }
            return size;
        },
        getFotoContainerBleed(/** HTMLElement */element) {
            const bleed = Number(element.getAttribute('data-bleed')) || 0;
            const dX = Number(element.closest('.book-page').getAttribute('data-dx')) || 1;
            return bleed / dX;
        },
        /** Show Edit photo dialog */
        editPhoto() {
            const container = this.closest('.foto-container');
            if (!container) {
                return;
            }

            const dataFilters = container.getAttribute('data-filters');
            const initialState = dataFilters ? JSON.parse(dataFilters) : {};

            const data = {
                container: {
                    id: Number(container.getAttribute('data-id')),
                    bleed: Fotobook.containers.getFotoContainerBleed(container),
                    foto_angle: Fotobook.book.getContainerFotoAngle(container),
                    ...Fotobook.containers.getRealSize(container),
                    ...self.getFramingArea(container),
                },
                image: self.getImageData(container),
                initialState,
            };

            Fotobook.store.dispatch('PhotoEditor/openEditor', data);
        },

        /** Получить выделенные контейнеры (содержат класс .selected) */
        getSelected() {
            return $(Fotobook.book.book).find('.page-container.selected');
        },

        /**
         * Проверяем, является ли контейнер календарём.
         *
         * @param $container
         * @returns {boolean}
         */
        isCalendar($container) {
            return $container.hasClass('calendar-container');
        },
    };

    $(document)
    .on("click", "html:not(.edit-mode-instant) .page-container.top-level:not(.locked) .low-quality-mark", function(){
        var pageContainer = $(this).closest(".page-container.top-level");
        if(!pageContainer.hasClass(Fotobook.CONT_SUBTYPE_FOTOWINDOW_CLASS)){
            self.setContainerOptimalQuality(pageContainer.attr("data-id"));
        }
    })

    .on("click", ".controls-button-wrapper .edit-foto", self.editPhoto)

    .on("click", ".delete-foto-instant", self.delFoto);
})();
